import { useCallback, useMemo } from 'react'
import { KeyRound } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchCredentialStuffing, SEC_STR as S, type CredStuffRow } from './securityMoreApi'

/**
 * A18.16 — Credential stuffing. High-volume login attempts against many accounts
 * from one source. Fail-soft empty until `/admin/security/credential-stuffing` ships.
 */
export function CredentialStuffingScreen() {
  const columns = useMemo<AdminColumn<CredStuffRow>[]>(
    () => [
      { key: 'target', header: S.target, type: 'text' },
      { key: 'ip', header: S.ip, type: 'text', width: 150 },
      { key: 'attempts', header: S.attempts, type: 'number', width: 110 },
      { key: 'failed', header: S.failedCount, type: 'number', width: 120 },
      { key: 'window', header: S.window, type: 'text', width: 160 },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 140,
        options: [
          { value: 'open', label: S.openLbl, status: 'open' },
          { value: 'mitigated', label: 'mitigated', status: 'review' },
          { value: 'cleared', label: S.cleared, status: 'active' },
        ],
      },
    ],
    [],
  )
  const fetcher = useCallback(fetchCredentialStuffing, [])
  return (
    <>
      <PageHeader title={S.credStuffing} screenId="A18.16" />
      <DataTable<CredStuffRow>
        screenId="A18.16"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <KeyRound size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
